<template>
    <div id="input-ral-page">
        <div v-if="!isMobile">
            <div>
                <ui5-file-uploader
                    @change="onUpload"
                    :disabled="processing"
                    :placeholder="
                        trans('pages.input_ral_page.file_upload.placeholder')
                    "
                    accept=".csv"
                    multiple="false"
                >
                    <ui5-button icon="upload">
                        {{ trans('pages.input_ral_page.file_upload.button') }}
                    </ui5-button>
                </ui5-file-uploader>
            </div>
            <div>
                <table>
                    <thead>
                        <tr>
                            <td>
                                {{
                                    trans(
                                        'pages.input_ral_page.table.line_count'
                                    )
                                }}
                            </td>
                            <td>
                                {{
                                    trans(
                                        'pages.input_ral_page.table.correctly_processed'
                                    )
                                }}
                            </td>
                            <td>
                                {{ trans('pages.input_ral_page.table.error') }}
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{{ csvCount }}</td>
                            <td>{{ csvCorrect }}</td>
                            <td>{{ csvError }}</td>
                        </tr>
                    </tbody>
                </table>
                <br />
                <spinner-text v-if="processing">
                    {{ trans('pages.input_ral_page.processing') }}
                </spinner-text>
            </div>
            <div v-html="csvErrorMsg" />
        </div>
    </div>
</template>
<script>
import SpinnerText from '../components/loader/SpinnerText';
import colorApi from '../api/color';
import * as Papa from 'papaparse';
import { isMobile } from '../helpers/GeneralHelper';
import { showInfoMessage, showErrorMessage } from '../dialogs';
import localization from '../mixins/localization';

export default {
    components: { SpinnerText },
    mixins: [localization],
    data() {
        return {
            processing: false,
            csvCount: 0,
            csvCorrect: 0,
            csvError: 0,
            csvErrorMsg: '',
        };
    },
    computed: {
        isMobile: () => isMobile(),
    },
    methods: {
        onUpload($event) {
            this.csvCount = 0;
            this.csvCorrect = 0;
            this.csvError = 0;
            this.csvErrorMsg = '';

            const files = $event.target.files; // FileList object
            Array.from(files).forEach((f) => {
                const reader = new FileReader();

                reader.onload = (() => {
                    return (e) => {
                        this.parseCsvRalFile(e.target.result);
                    };
                })(f);

                reader.readAsText(f);
            });
        },
        parseCsvRalFile(fileText) {
            this.processing = true;

            Papa.parse(fileText, {
                complete: (results) => {
                    this.csvCount = results.data.length;

                    showInfoMessage(
                        this.trans('pages.input_ral_page.messages.analysis', {
                            count: this.csvCount,
                        })
                    );

                    // Check for parsing errors
                    if (results.errors.length > 0) {
                        showErrorMessage(
                            this.trans('pages.input_ral_page.messages.format_errors')
                        );
                        this.processing = false;
                        results.errors.forEach((error) => {
                            this.csvError++;
                            this.csvErrorMsg +=
                                this.trans(
                                    'pages.input_ral_page.messages.line_error',
                                    { line: error.row, message: error.message }
                                ) + '<br/>';
                        });
                        return;
                    }

                    const rawLines = fileText
                        .split(/\r\n|\r|\n/)
                        .filter((x) => x.length > 0);

                    if (rawLines.length > 0) {
                        this.saveCsvColorsToServer(rawLines);
                    } else {
                        this.processing = false;
                        this.csvErrorMsg +=
                            '<br/>' +
                            this.trans('pages.input_ral_page.messages.nothing_saved') +
                            '<br/>';
                    }
                },
                delimiter: '', // Auto-detect delimiter (PapaParse built-in)
                skipEmptyLines: true,
                dynamicTyping: false,
            });
        },
        saveCsvColorsToServer(colors) {
            colorApi
                .import(colors)
                .then((response) => {
                    const count = response.data.data;
                    this.csvCorrect += count;
                    showInfoMessage(
                        this.trans(
                            'pages.input_ral_page.messages.colors_processed',
                            { count: this.csvCorrect }
                        )
                    );
                })
                .catch(() => {
                    this.csvError += 1;
                    this.csvErrorMsg +=
                        this.trans(
                            'pages.input_ral_page.messages.db_error'
                        ) + '<br/>';
                    showErrorMessage(
                        this.trans(
                            'pages.input_ral_page.messages.db_add_error'
                        )
                    );
                })
                .finally(() => {
                    this.processing = false;
                });
        },
    },
};
</script>
